



































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";
import { CommonApi } from "@/api/commonApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class NewsList extends Vue {
  newsApi = new NewsApi();
  commonApi = new CommonApi();
  active = "";
  dataList1: Array<object> = [];
  pageNum1 = 1;
  pageNum2 = 1;
  dataList2: Array<object> = [];
  weekHots: Array<object> = [];
  monthHots: Array<object> = [];
  latelyNews: Array<object> = [];
  listPage1 = 1;
  listTotal1 = 0;
  listPage2 = 1;
  listTotal2 = 0;
  adInfo = {};
  mounted() {
    this.active = this.$route.query.active.toString();
    this.getAdInfo();
    this.getDataList1();
    this.getDataList2();
    this.getLeftData();
  }
  changeTab(tabIdx: string) {
    this.active = tabIdx;
  }

  getAdInfo() {
    this.commonApi.getAdInfo(3).then((res) => {
      this.adInfo = res.data;
    });
  }

  getDataList1() {
    this.newsApi.getBasicContentByType(5, this.pageNum1, 6).then((res) => {
      this.dataList1 = res.data;
      this.listTotal1 = res.total;
    });
  }
  getDataList2() {
    this.newsApi.getBasicContentByType(6, this.pageNum2, 6).then((res) => {
      this.dataList2 = res.data;
      this.listTotal2 = res.total;
    });
  }
  getLeftData() {
    this.newsApi.getHotsData().then((res) => {
      this.weekHots = res.data.weekHots;
      this.monthHots = res.data.monthHots;
      this.latelyNews = res.data.latelyNews;
    });
  }
  changeListPage1(page: number, pageSize: number) {
    this.pageNum1 = page;
    this.getDataList1();
  }
  changeListPage2(page: number, pageSize: number) {
    this.pageNum2 = page;
    this.getDataList2();
  }
}
